import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <g strokeLinejoin="round" clipPath="url(#a)">
      <path
        fill="#DEEAEC"
        stroke="#DEEAEC"
        strokeWidth={0.6}
        d="M6.916 12.722a5.763 5.763 0 1 0 0-11.527 5.763 5.763 0 0 0 0 11.527Z"
      />
      <path
        stroke="#646F7C"
        strokeLinecap="round"
        strokeWidth={1.153}
        d="m8.546 5.328-3.26 3.26M5.286 5.328l3.26 3.26"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .043h13.832v13.832H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
